/*
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2025-08-26 14:22:26
 * @LastEditors: 刘小二
 * @LastEditTime: 2025-09-01 09:43:55
 * @Description:路由跳转处理
 * @FilePath: /icps_pcweb/src/utils/urlAuthHandler.js
 */
// src/utils/urlAuthHandler.js

import { getPermission } from '@/api/api';
import { getUserInfo } from '@/api/basedata/user.js';
import { setPerMission, setToken, setUserId, setUserInfo } from "@/utils/auth";

import Cookies from "js-cookie";

/**
 * 处理带 nav 参数的 URL 查询逻辑
 * @returns {Promise<boolean>} 是否成功处理并允许跳转
 */
export async function handleNavUrl() {
    try {
        let accessToken = Cookies.get('ICPS_accessToken');
        console.log("🚀 ~ handleNavUrl ~ accessToken:", accessToken)
        setToken(accessToken);

        const userData =  await getUserInfo();
        if (userData && userData.code == 1001) {
            setUserInfo(userData.data);
            setUserId(userData.data.userId);
        }

        const permissionData = await getPermission();
        if (permissionData && permissionData.code == 1001) {
            setPerMission(permissionData.data);
        }
        
        // 清理 URL 中的 path=nav 参数
        const url = new URL(window.location.href);
        if (url.searchParams.has('path')) {
            url.searchParams.delete('path');
            // 如果没有其他参数，确保 search 为空
            const newUrl = url.pathname + (url.search ? url.search : '') + url.hash;
            window.history.replaceState({}, document.title, newUrl);
        }

        return true;
    } catch (error) {
        console.error('处理 nav URL 时出错:', error);
        return false;
    }
}

/**
 * 解析 URL 查询参数并填充到 paramsObj
 * @param {string} searchStr - window.location.search 或 hash 中的查询部分
 * @param {Object} paramsObj - 目标对象
 */
export function parseUrlParams(searchStr, paramsObj) {
    const urlParams = new URLSearchParams(searchStr);
    for (const [key, value] of urlParams) {
        paramsObj[key] = value;
    }
    if (paramsObj.client_id) {
        paramsObj.appid = paramsObj.client_id;
    }
}